import React, { createContext, FC, useContext, useState } from 'react';

const AudioCompletionContext = createContext<Set<string> | undefined>(
  undefined
);

// Source credit belongs to this rendered slide, including its card portals.
// Question-record credit remains independent in SequenceStore.audioPlayed.
export const AudioCompletionProvider: FC = ({ children }) => {
  const [sources] = useState(() => new Set<string>());
  return (
    <AudioCompletionContext.Provider value={sources}>
      {children}
    </AudioCompletionContext.Provider>
  );
};

export const useCompletedAudioSources = () => {
  const sharedSources = useContext(AudioCompletionContext);
  const [localSources] = useState(() => new Set<string>());
  return sharedSources ?? localSources;
};
